import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function YourDataWho(props) {
  const { category } = props;
  return <FormattedMessage id={`offerWizard.yourData.who.${category}`} />;
}

YourDataWho.propTypes = {
  category: PropTypes.string.isRequired,
};

export default YourDataWho;
